import { render, staticRenderFns } from "./edge_buttons.vue?vue&type=template&id=208b0e86"
import script from "./edge_buttons.vue?vue&type=script&lang=js"
export * from "./edge_buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports